import { ORDERS_STATE_NAME } from '../orders.config';
export var TRANSFER_STATE_NAME = "".concat(ORDERS_STATE_NAME, ".transfer");
export default (function ($stateProvider) {
  $stateProvider.state(TRANSFER_STATE_NAME, {
    url: '/transfer',
    template: '<transfer class="u-flexKeepHeight"></transfer>'
  });
});